import PriceButton from "../components/PriceButton"
import React from "react"
import powerDown from "../images/shawna-friend-stretching.jpg"
import styles from "../styles/powerProgram.module.scss"

class PowerProgram extends React.Component {
  constructor(){
    super()
    this.state = {
      haveEthos:false,
      ethosTitle1: '',
      ethosTitle2: '',
      ethosTitle3: '',
      ethosTitle4: '',
      ethosTitle5: '',
    }
  }


  componentDidMount(){
    //Looks in localstorage to get values
    const finalEthos = localStorage.getItem('haveEthos')
    const ethos1=localStorage.getItem('ethos1Title')
    const ethos2=localStorage.getItem('ethos2Title')
    const ethos3=localStorage.getItem('ethos3Title')
    const ethos4=localStorage.getItem('ethos4Title')
    const ethos5=localStorage.getItem('ethos5Title')

    
    if(finalEthos==='true'){
      this.setState({
        haveEthos:finalEthos,
        ethosTitle1:ethos1,
        ethosTitle2:ethos2,
        ethosTitle3:ethos3,
        ethosTitle4:ethos4,
        ethosTitle5:ethos5,
      })
    }
    
  }



  render(){
  
    
  return (
    <div className={styles.program}>
      <div className={styles.program_img}>
        <img src={powerDown} alt="shawna and friend meditating" />
      </div>
      <div className={styles.program_txt}>
        <h2>
          <span className={styles.blue}>Power</span> • Program
        </h2>
        <h3>fitness | thought coaching</h3>
        <p>
          The Power Program allows access to both the Fitness and Thought
          Coaching video libraries. As a Power Program member, you’ll be able to
          Power Up with fitness videos and Power Down with thought coaching
          videos anytime, anywhere.
        </p>
        <p className={styles.program_txt__features}>FEATURES INCLUDED</p>
        <ul className={styles.program_txt_list}>
          <li>Full Access to Fitness Video Library</li>
          <li>Full Access to Thought Coaching Video Library</li>
        </ul>
        <div className={styles.program_btns}>
          <div>
          {this.state.haveEthos?  
              <PriceButton
              price={"14.95"}
            href={`https://member.empowerofyou.com/checkout/?add-to-cart=352&ethos1=${this.state.ethosTitle1}&ethos2=${this.state.ethosTitle2}&ethos3=${this.state.ethosTitle3}&ethos4=${this.state.ethosTitle4}&ethos5=${this.state.ethosTitle5}`}
            backgroundColor={"#9FE5E3"}
              outlineColor={"#9FE5E3"}
              label={"Pay Monthly"}
              length={"month"}
              fontSize={"18px"}
            />
            : 
            <PriceButton
              price={"14.95"}
              href={`https://member.empowerofyou.com/checkout/?add-to-cart=352`}
              backgroundColor={"#9FE5E3"}
              outlineColor={"#9FE5E3"}
              label={"Pay Monthly"}
              length={"month"}
              fontSize={"18px"}
            />
          }
            <p>$0.49 per day</p>
          </div>
          <div>
          {this.state.haveEthos?  
               <PriceButton
               href={`https://member.empowerofyou.com/checkout/?add-to-cart=353&ethos1=${this.state.ethosTitle1}&ethos2=${this.state.ethosTitle2}&ethos3=${this.state.ethosTitle3}&ethos4=${this.state.ethosTitle4}&ethos5=${this.state.ethosTitle5}`}
               backgroundColor={"#9FE5E3"}
               outlineColor={"#9FE5E3"}
               label={"Pay Yearly"}
               fontSize={"18px"}
               outlineColor={"#9FE5E3"}
               price={"164.45"}
               length={"year"}
             />
            : 
            <PriceButton
              href={"https://member.empowerofyou.com/checkout/?add-to-cart=353"}
              backgroundColor={"#9FE5E3"}
              outlineColor={"#9FE5E3"}
              label={"Pay Yearly"}
              fontSize={"18px"}
              outlineColor={"#9FE5E3"}
              price={"164.45"}
              length={"year"}
            />
          }
            <p>$0.45 per day</p>
          </div>
        </div>
      </div>
    </div>
  )
}
}

export default PowerProgram
